import { mapActions } from 'vuex';

import $ from 'jquery';

export default {
  name: 'GradeModal',

  data() {
    return {
      grade: '',
      gradeDesc: '',

      $gradeModal: null,
    };
  },

  computed: {
    c_isPostGradeDisabled() {
      return '' === this.grade;
    },
  },

  methods: {
    ...mapActions('QA/Question', {
      ma_postQaGrade: 'postQaGrade',
    }),

    async postQaGrade() {
      await this.ma_postQaGrade({
        qaQuestionId: this.$route.params.id,
        commentLevel: this.grade,
        commentContent: this.gradeDesc,
      });
      this.$emit('post-qa-grade-done');
    },

    show() {
      this.$gradeModal.modal('show');
    },

    hide() {
      this.$gradeModal.modal('hide');
    },
  },

  mounted() {
    this.$gradeModal = $(this.$refs.gradeModal);
    this.$gradeModal.on('hidden.bs.modal', () => {
      this.$emit('qa-grade-modal-hidden');
    });
  },
};
